import { RouteProp } from '@react-navigation/native';
import React from 'react';
import { ProfilesTabParamList } from '../../../../../utils/appNavigationNames';
import Chat from './Chat';
import { colors } from '../../../../../utils/theme';
import { View } from 'react-native';
import ProfileHeaderContainer from '../../../../v2BaseComponents/ProfileHeaderContainer';
import { useChat } from '../../../../../hooks/api/useChat';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';

export type ChatScreenOwnProps = {};

export type ChatScreenProps = ChatScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'chat'>;
};

const ChatScreenScreen: React.FC<ChatScreenProps> = (props) => {
    const { chats, isLoadingChats } = useChat({
        medicalProfileId: props.route.params.profileId,
    });
    const blockForLoadingDefaultChat = !!props.route.params.defaultChatId && isLoadingChats;
    const validatedDefaultChatId = props.route.params.defaultChatId
        ? chats?.items.find((chat) => chat.chatId === props.route.params.defaultChatId)?.chatId || undefined
        : undefined;

    return (
        <ProfileHeaderContainer profileId={props.route.params.profileId} bottomBorder omitChatButton>
            <AnimateLoadedContent isLoading={blockForLoadingDefaultChat}>
                {() => (
                    <View style={{ width: '100%', height: '100%', backgroundColor: colors.White }}>
                        <Chat
                            medicalProfileId={props.route.params.profileId}
                            defaultChatId={validatedDefaultChatId}
                            key={props.route.params.defaultChatId}
                            defaultChatPrompt={props.route.params.defaultPrompt}
                            disableSetDefaultChat={props.route.params.disableSetDefaultChat === 'true'}
                        />
                    </View>
                )}
            </AnimateLoadedContent>
        </ProfileHeaderContainer>
    );
};

export default React.memo(ChatScreenScreen);
